import { render, staticRenderFns } from "./AssetTypeDelete.vue?vue&type=template&id=415e86bf"
import script from "./AssetTypeDelete.vue?vue&type=script&lang=js"
export * from "./AssetTypeDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports